module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "dedication",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('span', {
    attrs: {
      "aria-label": "page v",
      "epub:type": "pagebreak",
      "id": "page_v",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("To all the girls out there who want to be president one day. You can do it!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da90898c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781534440180/xhtml/dedication.vue
// module id = 60
// module chunks = 0